import { Switch } from '@mantine/core';

export interface BooleanFilterProps {
  description?: string;

  isDisabled?: boolean;

  label: string;

  checked: boolean;
  onChange: (checked: boolean) => void;

  flex?: number;
}

export function BooleanFilter(props: BooleanFilterProps) {
  const { label, description, isDisabled, checked, onChange, flex } = props;

  return (
    <Switch
      label={label}
      description={description}
      disabled={isDisabled}
      checked={checked}
      onChange={event => onChange(event.currentTarget.checked)}
      flex={flex ?? 1}
    />
  );
}
